import { render } from "./ClientIndex.vue?vue&type=template&id=1c5f10d4&scoped=true"
import script from "./ClientIndex.vue?vue&type=script&lang=js"
export * from "./ClientIndex.vue?vue&type=script&lang=js"

import "./ClientIndex.vue?vue&type=style&index=0&id=1c5f10d4&lang=scss&scoped=true"

import exportComponent from "/home/runner/work/translation_system/translation_system/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1c5f10d4"]])

export default __exports__